import { IEnableSpecifiable } from "../../../../base/domain/drawing";

export interface IHisInformationItemDefaultSelectBehavior extends IEnableSpecifiable {
  kind: HisInformationItemDefaultSelectKinds;
}

export enum HisInformationItemDefaultSelectKinds {
  None = 0,
  Top = 1,
  CreatedDate = 2,
  Bottom = 3,
}
